import styled, { css } from 'styled-components'

export interface FilterPanelContainerProps {
  $collapsed?: boolean
}

export interface FilterToggleProps {
  $collapsed?: boolean
}

export const Container = styled.aside.withConfig({
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})<FilterPanelContainerProps>`
  width: 320px;
  background: ${({ theme }) => theme.colors.background.primary};
  border-right: 1px solid ${({ theme }) => theme.colors.border.primary};
  display: flex;
  flex-direction: column;
  transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 100;
  position: relative;
  height: 100%;

  ${({ $collapsed }) =>
    $collapsed &&
    css`
      margin-left: -320px;
    `}

  @media (max-width: 768px) {
    position: absolute;
    z-index: 200;
    height: 100%;
    width: calc(100% - 80px);
    transform: translateX(0);
    transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    margin-left: 0;

    ${({ $collapsed }) =>
      $collapsed &&
      css`
        margin-left: calc((100% - 80px) * -1);
      `}
  }
`

export const FilterHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const FilterTitle = styled.h2`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
`

export const FilterContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
`

export const FilterToggle = styled.button.withConfig({
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})<FilterToggleProps>`
  position: absolute;
  right: -32px;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 64px;
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  border-left: none;
  border-radius: 0 ${({ theme }) => theme.borderRadius.medium}
    ${({ theme }) => theme.borderRadius.medium} 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.text.secondary};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 101;

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
  }

  .icon {
    width: 16px;
    height: 16px;
    stroke: currentColor;
    stroke-width: 2;
    fill: none;
    transform: rotate(180deg);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  ${({ $collapsed }) =>
    $collapsed &&
    css`
      .icon {
        transform: rotate(0deg);
      }
    `}

  @media (max-width: 768px) {
    position: fixed;
    right: 80px;
    left: auto;
    top: 50%;
    transform: translateY(-50%);
    width: 32px;
    height: 64px;
    border-radius: 0 ${({ theme }) => theme.borderRadius.medium}
      ${({ theme }) => theme.borderRadius.medium} 0;
    border: 1px solid ${({ theme }) => theme.colors.border.primary};
    border-left: none;
    background: ${({ theme }) => theme.colors.background.primary};
    color: ${({ theme }) => theme.colors.text.secondary};
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 400;

    ${({ $collapsed }) =>
      $collapsed &&
      css`
        right: auto;
        left: 0;
      `}
  }
`

export const ResetButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: pointer;
  padding: 4px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
    background: ${({ theme }) => theme.colors.background.tertiary};
  }

  .icon {
    width: 16px;
    height: 16px;
    stroke: currentColor;
    stroke-width: 2;
    fill: none;
  }
`
